import { isEmpty as isHtmlEmpty } from '@paintscout/util/util'
import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const fields = block?.fields
  if (!fields) {
    return true
  }

  const hasContent = fields.content && !isHtmlEmpty(fields.content)

  if (!hasContent && !fields.image) {
    return true
  }

  return false
}
